import { render, staticRenderFns } from "./IncomeExpenditureDetail.vue?vue&type=template&id=45a31dc2&scoped=true&"
import script from "./IncomeExpenditureDetail.vue?vue&type=script&lang=ts&"
export * from "./IncomeExpenditureDetail.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeExpenditureDetail.vue?vue&type=style&index=0&id=45a31dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a31dc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBreadcrumbs,VBtn,VCard,VDataTable,VDatePicker,VDivider,VFlex,VForm,VLayout,VList,VListTile,VListTileTitle,VMenu,VProgressCircular,VSelect,VSpacer,VTextField,VTextarea,VToolbar,VToolbarTitle})
